import { useMemo } from 'react';
import { type Page } from '#shared/api/schema';
import { useConstructorPagesSettings } from '../model/slices';

const getTemplateCount = (pages: { [key: string]: Page }, templateId?: string) => {
    if (!templateId) {
        return 0;
    }

    let count = 0;

    Object.values(pages).forEach((page: Page) => {
        page.layout.forEach((section) => {
            if (section.template_id === templateId) {
                count++;
            }
        });
    });

    return count;
};

const getPagesWithTemplate = (pages: { [key: string]: Page }, templateId?: string) => {
    if (!templateId) {
        return [];
    }

    return Object.values(pages).filter((page: Page) =>
        page.layout.some((section) => section.template_id === templateId)
    );
};

export function useConstructorCountTemplates({ templateId }: { templateId?: string }): {
    templateCount: number;
    pagesWithTemplate: Page[];
} {
    const pages = useConstructorPagesSettings();

    const templateCount = useMemo(() => getTemplateCount(pages, templateId), [pages, templateId]);

    const pagesWithTemplate = useMemo(() => getPagesWithTemplate(pages, templateId), [pages, templateId]);

    return {
        templateCount,
        pagesWithTemplate,
    };
}
